export const ManageStocksdata = [
    {
      Warehouse: "Lobar Handy",
      Shop: "Selosy",
      Product: {
        Name: "Nike Jordan",
        Image: "assets/img/products/stock-img-02.png"
      },
      Date: "25 Jul 2023",
      Person: {
        Name: "Steven",
        Image: "assets/img/users/user-08.jpg"
      },
      Quantity: 120
    },
    {
      Warehouse: "Quaint Warehouse",
      Shop: "Logerro",
      Product: {
        Name: "Apple Series 5 Watch",
        Image: "assets/img/products/stock-img-03.png"
      },
      Date: "28 Jul 2023",
      Person: {
        Name: "Gravely",
        Image: "assets/img/users/user-04.jpg"
      },
      Quantity: 130
    },
    {
      Warehouse: "Traditional Warehouse",
      Shop: "Vesloo",
      Product: {
        Name: "Amazon Echo Dot",
        Image: "assets/img/products/stock-img-04.png"
      },
      Date: "24 Jul 2023",
      Person: {
        Name: "Kevin",
        Image: "assets/img/users/user-09.jpg"
      },
      Quantity: 140
    },
    {
      Warehouse: "Cool Warehouse",
      Shop: "Crompy",
      Product: {
        Name: "Lobar Handy",
        Image: "assets/img/products/stock-img-05.png"
      },
      Date: "15 Jul 2023",
      Person: {
        Name: "Grillo",
        Image: "assets/img/users/user-10.jpg"
      },
      Quantity: 150
    }
  ]
  